export const USER_CONSTANT = {
  // csvファイル名
  CSV_FILENAME: 'user',
  TARGET_TABLE: 'user_department'
};
